<template>
  <v-modal
    size="sm"
    @hide-modal="$emit('hide-modal')"
  >
    <template v-slot:title>
      <h3>
        {{ $t('phrase.edit_information') }}
      </h3>
    </template>
    <template v-slot:body>
      <form method="post" @submit.prevent="submit">
        <div class="mb-3">
          <v-text-input
            id="organisation-modal-name"
            label="word.organisation_name"
            v-model="data.name"
            :errors="errors.name"
          />
        </div>

        <div class="mb-3">
          <v-text-input
            id="organisation-modal-address"
            label="word.address"
            v-model="data.address"
            :errors="errors.address"
          />
        </div>

        <div class="mb-3">
          <v-text-input
            id="organisation-modal-zip"
            label="word.zip"
            v-model="data.zip"
            :errors="errors.zip"
          />
        </div>

        <div class="mb-3">
          <v-text-input
            id="organisation-modal-city"
            label="word.city"
            v-model="data.city"
            :errors="errors.city"
          />
        </div>

        <div class="mb-3">
          <v-text-input
            id="organisation-modal-phone"
            label="word.phone"
            v-model="data.phone"
            :errors="errors.phone"
          />
        </div>

        <div class="mb-3">
          <v-text-input
            id="organisation-modal-website"
            label="word.website"
            v-model="data.website"
            :errors="errors.website"
          />
        </div>

        <v-button
          id="organisation-modal-submit"
          text="word.save"
          :block="true"
          type="submit"
          :loader="loader"
        />
      </form>
    </template>
  </v-modal>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Modal from '@/common/components/Modal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { mapGetters } from 'vuex';
import { notify } from '@/common/utils/notify';
import { GenericFormMixin } from '@/common/utils/mixins';

export default {
  name: 'OrganisationUpdateModal',
  mixins: [
    GenericFormMixin,
  ],
  components: {
    'v-button': Button,
    'v-modal': Modal,
    'v-text-input': TextInput,
  },
  computed: {
    ...mapGetters(['org']),
  },
  methods: {
    postProcess(response) {
      const { data } = response;
      this.$store.commit('updateOrg', data);

      notify('phrase.edit_success');
      this.$emit('hide-modal');
    },
    getApiPath() {
      return `organisations/${this.org.slug}/`;
    },
  },
  data() {
    return {
      apiMethod: 'patch',
      data: {
        name: null,
        address: null,
        zip: null,
        city: null,
        phone: null,
        website: null,
      },
    };
  },
  created() {
    this.data.name = this.org.name;
    this.data.address = this.org.address;
    this.data.zip = this.org.zip;
    this.data.city = this.org.city;
    this.data.phone = this.org.phone;
    this.data.website = this.org.website;
  },
};
</script>
